import { useCallback, useEffect, useState } from 'react';
import { httpClient, ROOT_URL } from '../../App';
import { useNotification } from '@refinedev/core';
import { getErrorMessage } from '../../api/error';
import { IBank } from '../../interfaces/banks';

export const useBank = (id?: number) => {
  const [data, setData] = useState<IBank>();
  const [isLoading, setIsLoading] = useState(false);
  const { open: openNotification } = useNotification();

  const fetch = useCallback(async () => {
    if (id === undefined) {
      return;
    }
    setIsLoading(true);
    try {
      const result = await httpClient.get(`${ROOT_URL}/api/v1/banks/${id}`);
      if (result.status === 200) {
        setData(result.data);
      }
    } catch (error) {
      const message = getErrorMessage(error);
      setData(undefined);
      if (openNotification) {
        openNotification({
          key: 'edit_failure',
          message: `Error loading bank #${id}`,
          description: message || 'Something went wrong',
          type: 'error',
        });
      }
    }
    setIsLoading(false);
  }, [id, setData, openNotification]);

  const clearData = useCallback(() => {
    setData(undefined);
  }, []);

  useEffect(() => {
    if (id === undefined) {
      clearData();
    } else {
      fetch();
    }
  }, [id, clearData, fetch]);

  return {
    data,
    fetch,
    isLoading,
    clearData,
  };
};
